import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'missionNameFormat',
    pure: true,
    standalone: false
})
export class MissionNameFormatPipe implements PipeTransform {
  transform(row: any, ...args: unknown[]): string {
    return 'M' + row.mission.id.substring(0, 8) + ' (' + row.mission.plateNumber + ')';
  }
}